import { Component, DestroyRef, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { WizardSection } from '@app/models/project-setup.models';
import { WizardStore } from '@app/stores/project-setup/wizard.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { ValidatedTextAreaComponent } from '@app/ui-components/validated-textarea/validated-textarea.component';
import { SectionFFormGroup } from '../+helpers/section-f-form.helper';

@Component({
  selector: 'app-section-f',
  imports: [ReactiveFormsModule, CardComponent, ValidatedTextAreaComponent],
  templateUrl: './section-f.component.html',
  styleUrl: './section-f.component.scss',
})
export class SectionFComponent {
  wizardStore = inject(WizardStore);
  projectId = input.required<string>();
  protected formGroup = signal<FormGroup<SectionFFormGroup> | null>(null);
  protected translationKey = 'projectWizard.sectionFForm.';

  constructor(private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.wizardStore
      .getSection(this.projectId(), WizardSection.F)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) =>
        this.formGroup.set(data as FormGroup<SectionFFormGroup>)
      );
  }
}
